import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-actionable-selector',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ``,
  styles: ``,
})
export class CpActionableSelectorComponent {}
